<template>
    <div class="@container/mh-contact pt-4 pb-0 px-4 flex flex-col overflow-hidden md:p-0">
        <div class="md:hidden">
            <router-link
                class="text-sm"
                :to="{
                    name: 'message-hub.conversation',
                    params: {
                        contactId: route.params.contactId,
                    },
                    query: route.query,
                }"
            >
                <font-awesome-icon widthAuto :icon="faArrowLeft"></font-awesome-icon>
                Message
            </router-link>
            <div class="text-xl font-extrabold mb-3 md:mb-6 md:text-2xl">Contact Details</div>
        </div>
        <vx-box class="grow max-h-full scroll-thin overflow-auto py-5 px-6">
            <div
                class="hidden flex-col-reverse gap-6 mb-2 md:flex @sm/mh-contact:flex-row @sm/mh-contact:justify-between"
            >
                <div class="font-extrabold">Contact Details</div>
                <router-button
                    :to="{
                        name: 'message-hub.conversation',
                        params: { contactId: route.params.contactId },
                        query: route.query,
                        replace: true,
                    }"
                    size="md"
                    color="muted"
                    class="-mt-1 -mb-1"
                >
                    <font-awesome-icon widthAuto :icon="faCaretLeft"></font-awesome-icon>
                    Hide Details
                </router-button>
            </div>
            <contact-view-content
                :editableRelationships="true"
                @currentGroupRemoved="onCurrentGroupRemoved"
            ></contact-view-content>
        </vx-box>
    </div>
</template>

<script setup>
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { faCaretLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox } from '@voxie/frontend-components';
import { watch } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import ContactViewContent from '~/components/contacts/contact/view/ContactViewContent.vue';
import RouterButton from '~/components/general/RouterButton.vue';
import { useContactDetails } from '../contacts/contact/useContactDetails';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const route = useRoute();
const router = useRouter();

const { currentGroup } = useCurrentGroup();

const { mount: mountContact } = useContactDetails();

const onCurrentGroupRemoved = () => {
    router.push({
        name: 'message-hub',
        query: route.query,
    });
};

watch(
    () => route.params.contactId,
    (contactId) => {
        mountContact(contactId, route.query.group || currentGroup.value?.group_id);
    },
    {
        immediate: true,
    }
);
</script>
